module.exports = __webpack_public_path__ + "static/media/logo10.13a3fab6.png";